import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './DevicesLoading.Styles';

const headerLoadingConfig = [
  {
    left: setLoadingConfigObject('line', 1, 174, styles.headerFirstLine),
  },
  {
    left: setLoadingConfigObject('line', 1, 248, styles.headerSecondLine),
  },
];

const squareLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.squareStyle(100)),
    style: styles.squareContianer,
  },
];

const titleLoadingConfig = isFirstTitle => [
  {
    left: setLoadingConfigObject('line', 1, 64, styles.titleFirstLine),
  },
  {
    left: setLoadingConfigObject('line', 1, 137, styles.titleSecondLine(isFirstTitle)),
  },
];

const footerLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.footerSeparator),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.footerButton),
  },
];

const showMoreLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, styles.showMore),
    style: styles.showMoreLoadingContainer,
  },
];
export {
  headerLoadingConfig,
  squareLoadingConfig,
  titleLoadingConfig,
  footerLoadingConfig,
  showMoreLoadingConfig,
};
